import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import messages from './documentMessages';
import AuthService, { functionalities, privileges } from '@/shared/services/AuthService';

const DocumentGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onUpdateTags,
    onUpdateRelations,
    onRemoveDocuments,
    onDownloadZip,
    onSendByEmail,
    onSetIsPublicOnPortal,
    onChangeDocumentDate,
    onCreateMergePdf,
    onSendSignatureRequest,
    onChangeDocumentType,
    onChangeSigningStatus,
    onChangeReferenceYear,
    onExtractDataWithAI,
  } = props;

  const hasAIFeature =
    AuthService.hasFeature('AI') &&
    AuthService.hasPermission({ functionality: functionalities.AI, privilege: privileges.Update });
  const hasReferenceYearFeature = AuthService.hasFeature('ReferenceYear');

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.DocumentGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItemWithSecurity
          onSelect={onUpdateTags}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.AddOrRemoveTags)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateRelations}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.AddOrRemoveRelations)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onDownloadZip}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Read}
        >
          {intl.formatMessage(messages.DownloadAsZip)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onCreateMergePdf}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Read}
        >
          {intl.formatMessage(messages.CreateMergedPdf)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onSendByEmail}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Read}
        >
          {intl.formatMessage(messages.SendByEmail)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onSendSignatureRequest}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.SendSignatureRequest)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onSetIsPublicOnPortal}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.EnableOrDisableIsPublicOnPortal)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onChangeDocumentDate}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.ChangeDocumentDate)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onChangeDocumentType}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.ChangeDocumentType)}
        </MenuItemWithSecurity>
        {hasReferenceYearFeature && (
          <MenuItemWithSecurity
            onSelect={onChangeReferenceYear}
            disabled={disabled}
            functionality={functionalities.Documents}
            privilege={privileges.Update}
          >
            {intl.formatMessage(messages.ChangeReferenceYear)}
          </MenuItemWithSecurity>
        )}
        <MenuItemWithSecurity
          onSelect={onChangeSigningStatus}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.ChangeSigningStatus)}
        </MenuItemWithSecurity>
        {hasAIFeature && (
          <MenuItemWithSecurity
            onSelect={onExtractDataWithAI}
            disabled={disabled}
            functionality={functionalities.Relation}
            privilege={privileges.Update}
          >
            {intl.formatMessage(messages.ExtractDataWithAI)}
          </MenuItemWithSecurity>
        )}
        <MenuItemWithSecurity
          onSelect={onRemoveDocuments}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Delete}
        >
          {intl.formatMessage(messages.RemoveDocuments)}
        </MenuItemWithSecurity>
      </DropdownButton>
    </span>
  );
};

DocumentGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
};
DocumentGlobalActionsButton.defaultProps = {
  disabled: false,
};

export default injectIntl(DocumentGlobalActionsButton);
